import produce from "immer";
import {
  SET_ALL_USERS,
  LOADER_STATUS,
  SET_CREATE_USER_MODAL,
  GET_ALL_COMPANIES,
  SET_ALL_STATE_CODE,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  isModalActive: false,
  users: [],
  companies: [],
  stateCodes: [],
};

const manageHsncodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SET_ALL_USERS:
      return {
        ...state,
        users: action.users,
      };
    case SET_CREATE_USER_MODAL:
      return {
        ...state,
        isModalActive: action.isModalActive,
      };
    case GET_ALL_COMPANIES:
      return {
        ...state,
        companies: action.payload,
      };
    case SET_ALL_STATE_CODE:
      return {
        ...state,
        stateCodes: action.stateCodes,
      };
    default:
      return state;
  }
};

export default manageHsncodeReducer;
